



export default {
data () {
return {
height: screen.height -46
}
},
components: {

},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/common/components/SaafContent.vue